// import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
// 
// import { currentProjectActiveDomainsSelector } from '../../reducers/selectors';
// 
// const mapStateToProps = state => ({ domains: currentProjectActiveDomainsSelector(state), links: state.links });
// 
// const matchDispatchToProps = dispatch => {
//   return bindActionCreators({}, dispatch)
// };
// 
import find from 'lodash/find';
const DEFAULT_DOMAIN = 'shor.by';

const shortUrl = ({ short_url, id, domain_id, slug, unique_slug, custom_slug, links, domains }) => {
  if ( short_url )
    return short_url
  
  const link = id && links && links[id];
  
  if ( link && link.short_url ){
    return link.short_url
  }
  else {
    const slashtag = slug || custom_slug || unique_slug;
    const domain = domain_id && find(domains, ['id', (domain_id)]);
    const host = domain && domain.name ? `http://${domain.name}` : `https://${DEFAULT_DOMAIN}`
    
    return `${host}/${(slashtag || '').replace('/', '')}`;
  }
}

// export default connect(mapStateToProps, matchDispatchToProps)(ShortUrl);
export default shortUrl;


// WEBPACK FOOTER //
// ./src/components/helpers/ShortUrl.js